import { render, staticRenderFns } from "./TextIfValueSettings.vue?vue&type=template&id=0828c601"
import script from "./TextIfValueSettings.vue?vue&type=script&lang=ts"
export * from "./TextIfValueSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0828c601')) {
      api.createRecord('0828c601', component.options)
    } else {
      api.reload('0828c601', component.options)
    }
    module.hot.accept("./TextIfValueSettings.vue?vue&type=template&id=0828c601", function () {
      api.rerender('0828c601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reportengine/TextIfValueSettings.vue"
export default component.exports